
import { ReactNode } from "react";
import CarStat from "./gameCarStat.tsx";
import { CarColor } from "../lib/definitions.ts";


export type lapData = {
    bonustxt : Array<string>
    timetxt : Array<string>
    txtnitros : Array<string>
    txtdmg : Array<string>
    color:Array<CarColor>
}

type GameStatProp = {
    laps : lapData,
    lapid:string
    carsidx:Array<number>
}


const GameLapStats = (props: GameStatProp): ReactNode => {

    const prefix = "lap"+props.lapid+"-";
    const carsidx = props.carsidx;


    const lapBonuses = props.laps.bonustxt.map( (txt , idx) => <CarStat infos = {props.laps.bonustxt[carsidx[idx]]} key={"bonus-"+carsidx[idx]} color = {props.laps.color[carsidx[idx]]} carid = {carsidx[idx]} />);
    const lapTimes = props.laps.timetxt.map( (txt , idx) => <CarStat infos = {props.laps.timetxt[carsidx[idx]]}  key={"time-"+carsidx[idx]} color = {props.laps.color[carsidx[idx]]} carid = {carsidx[idx]} />);
    const lapDmgs = props.laps.txtdmg.map( (txt , idx) => <CarStat infos = {props.laps.txtdmg[carsidx[idx]]}  key={"dmg-"+carsidx[idx]} color = {props.laps.color[carsidx[idx]]} carid = {carsidx[idx]} />);
    const lapNitros = props.laps.txtnitros.map( (txt , idx) => <CarStat infos = {props.laps.txtnitros[carsidx[idx]]}  key={"nitro-"+carsidx[idx]} color = {props.laps.color[carsidx[idx]]} carid = {carsidx[idx]} />);
    

    return (    <tr id={prefix+"row"}>
                    <td> #{props.lapid}</td>
                    <td id={prefix+"bonus"}>{lapBonuses}</td>
                    <td id={prefix+"time"}>{lapTimes}</td>
                    <td id={prefix+"dmg"}>{lapDmgs}</td>
                    <td id={prefix+"nitro"}>{lapNitros}</td>
                </tr>
            )

}

export default GameLapStats;